import { Link } from 'react-router-dom';
import { IoHome } from "react-icons/io5";
import imgThanks from '../../../assets/images/form/gracias.webp';

export function Thanks() {
    return (
        <section className="thanks bg-section-secondary py-5 d-flex align-items-center">
            <div className='thanks__container container'>
                <div className='thanks__box row'>
                    <div className='thanks__image d-flex align-items-center col-12 col-lg-6 pe-lg-4 mb-5 mb-lg-0'>
                        <img className='thanks__img w-100' src={imgThanks} alt="Imagen gracias" />
                    </div>
                    <div className='thanks__text d-lg-flex flex-column align-items-center justify-content-center text-center col-12 col-lg-6 ps-lg-4'>
                        <h1 className='thanks__title mb-4'>¡GRACIAS POR CONTACTARNOS!</h1>
                        <h4 className='thanks__description mb-5'>Estamos revisando su mensaje y nos comunicaremos pronto.</h4>
                        <Link className='thanks__btn text-center' to="/">
                            <IoHome className='me-2 mb-1' />
                            Ir a Inicio
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}